module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/student-desktop.component.css
// module id = ./src/app/student-desktop.component.css
// module chunks = main